import React from "react";
import { Box } from "@mui/material";

type MuPowerArchitectureTabPanelProps = {
  children: React.ReactNode;
  value: number;
  id: number;
};

const MuPowerArchitectureTabPanel: React.FC<MuPowerArchitectureTabPanelProps> = ({ children, value, id }: MuPowerArchitectureTabPanelProps) => (
  <Box
    role="tabpanel"
    hidden={value !== id}
    id={`mu-power-architecture-tabpanel-${id}`}
    aria-labelledby={`mu-power-architecture-tab-${id}`}
    sx={{ pt: 2 }}
  >
    {children}
  </Box>
);

export default MuPowerArchitectureTabPanel;
